'use strict';

export default function bind(fn, thisArg) {
  return function wrap() {
    return fn.apply(thisArg, arguments);
  };
}



//////////////////
// WEBPACK FOOTER
// ./~/_axios@1.4.0@axios/lib/helpers/bind.js
// module id = 68
// module chunks = 1